import './App.css';

function App() {
  return (
    <div className="App">
      <p>
        Aplikasi RStok ini dibuat secara gratis untuk pengunaan sehari-hari sebagai pencatatan stok.
        pembelian, penjualan barang.
      </p>
    </div>
  );
}

export default App;
